import gql from "/vendor/graphql-tag";
import { useRouter } from "/lib/component/util";

const EventDetailsGoToCheckAction = ({ children, event }) => {
  const { history, match } = useRouter();

  const checkName = event.check && event.check.name;
  const namespace = event.namespace || match.params.namespace;
  const canGoToCheck = !!checkName && checkName !== "keepalive";

  const goToCheck = () => {
    if (!canGoToCheck) {
      return;
    }
    const prefix = match.params.cluster ? `/c/${match.params.cluster}` : "";
    history.push(
      `${prefix}/n/${encodeURIComponent(namespace)}/checks/${encodeURIComponent(
        checkName,
      )}`,
    );
  };

  return children({ goToCheck, canGoToCheck });
};

EventDetailsGoToCheckAction.fragments = {
  event: gql`
    fragment EventDetailsGoToCheckAction_event on Event {
      check {
        name
      }
      namespace
    }
  `,
};

export default EventDetailsGoToCheckAction;
